'use client';

import { type JSX } from 'react';

import { ToastTitle } from '../_components/Toast/ToastTitle';
import { AI_TOOLKIT_CATEGORIES, type AiToolkitCategory } from './types';

type ActiveTaskToastConfig = {
    inProgressTitle: JSX.Element;
    successTitle: JSX.Element;
    errorTitle: JSX.Element;
};

export const ACTIVE_TASK_TOAST_CONFIG: Record<AiToolkitCategory, ActiveTaskToastConfig> = {
    [AI_TOOLKIT_CATEGORIES.VIDEO_GENERATION]: {
        inProgressTitle: (
            <ToastTitle
                category={AI_TOOLKIT_CATEGORIES.VIDEO_GENERATION}
                status="inProgress"
                href="/ai/video-generation"
            />
        ),
        successTitle: (
            <ToastTitle
                category={AI_TOOLKIT_CATEGORIES.VIDEO_GENERATION}
                status="success"
                href="/ai/video-generation"
            />
        ),
        errorTitle: (
            <ToastTitle category={AI_TOOLKIT_CATEGORIES.VIDEO_GENERATION} status="error" href="/ai/video-generation" />
        ),
    },
    [AI_TOOLKIT_CATEGORIES.IMAGE_GENERATION]: {
        inProgressTitle: (
            <ToastTitle
                category={AI_TOOLKIT_CATEGORIES.IMAGE_GENERATION}
                status="inProgress"
                href="/ai/image-generation"
            />
        ),
        successTitle: (
            <ToastTitle
                category={AI_TOOLKIT_CATEGORIES.IMAGE_GENERATION}
                status="success"
                href="/ai/image-generation"
            />
        ),
        errorTitle: (
            <ToastTitle category={AI_TOOLKIT_CATEGORIES.IMAGE_GENERATION} status="error" href="/ai/image-generation" />
        ),
    },
    [AI_TOOLKIT_CATEGORIES.VOICEOVER]: {
        inProgressTitle: (
            <ToastTitle category={AI_TOOLKIT_CATEGORIES.VOICEOVER} status="inProgress" href="/ai/voiceover" />
        ),
        successTitle: <ToastTitle category={AI_TOOLKIT_CATEGORIES.VOICEOVER} status="success" href="/ai/voiceover" />,
        errorTitle: <ToastTitle category={AI_TOOLKIT_CATEGORIES.VOICEOVER} status="error" href="/ai/voiceover" />,
    },
    // [AI_TOOLKIT_CATEGORIES.VIDEO_EDIT]: {
    //     inProgressTitle: <ToastTitle category={AI_TOOLKIT_CATEGORIES.VIDEO_EDIT} status="inProgress" href="/ai/video-edit" />,
    //     successTitle: <ToastTitle category={AI_TOOLKIT_CATEGORIES.VIDEO_EDIT} status="success" href="/ai/video-edit" />,
    //     errorTitle: <ToastTitle category={AI_TOOLKIT_CATEGORIES.VIDEO_EDIT} status="error" href="/ai/video-edit" />,
    // },
};
